import * as React from "react";
function SvgIcDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 13.123l-.373-.64-6.254 3.586V4h-.746v12.069l-6.254-3.587-.373.64 7 4.015 7-4.014zM5.672 19.258H18.36v.74H5.67v-.74z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcDownload;
